import React, {Component, Fragment} from 'react'
import AuthenticationService from "../../../Services/AuthenticationService";
import EmailDomainService from "../../../Services/EmailDomainService";
import Grid from "@material-ui/core/Grid";
import {  
    Button, 
    TextField, 
    IconButton, 
    Typography, 
    Paper, 
    withStyles, 
    Snackbar,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import {isEmpty} from "../../../utils/Utils";


const styles = theme => ({
    root: {
        width: '100%',
    },
    button: {
        margin: theme.spacing.unit,
        cursor: 'pointer',
        color: '#0f197d',
        marginLeft: theme.spacing(2),
        height: 36,
        alignSelf: 'flex-end'
    },
    input: {
        display: 'none',
    },
    domainsBox: {
        border: '1px solid #e0e0e0',
        borderRadius: '4px',
        padding: theme.spacing(2),
        marginTop: theme.spacing(2),
        minHeight: '100px',
        backgroundColor: '#fafafa'
    },
    domainsList: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
    },
    domainItem: {
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #e0e0e0',
        borderRadius: '4px',
        padding: '4px 8px',
        backgroundColor: '#ffffff'
    },
    emptyMessage: {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        fontStyle: 'italic'
    },
    inputContainer: {
        display: 'flex',
        alignItems: 'flex-start',
        width: '100%'
    },
    errorSnackbar: {
        backgroundColor: theme.palette.error.dark,
    },
    deleteButton: {
        color: theme.palette.error.main
    }
});

window.analytics = {pageName:'Email Domains: Update'};

class EmailDomains extends Component {
    
    constructor(props) {
        super(props);
        this.state = {            
            emailDomain: '',
            items: [],            
            errorMsg: '',
            isLoading: false,
            saveSuccess: false,
            showErrorSnackbar: false,
            errorSnackbarMsg: '',
            confirmDialogOpen: false,
            domainToDelete: null
        }  
    }

    loadDomains = () => {
        this.setState({ isLoading: true });
        
        EmailDomainService.getRestrictedDomains()
            .then(response => {
                if (response && response.status >= 200 && response.status < 300) {
                    this.setState({ 
                        items: response.data || [], 
                        isLoading: false 
                    });
                } else {
                    throw new Error('Failed to load domains');
                }
            })
            .catch(error => {
                const errorMessage = error.response?.data?.message || 
                                    error.response?.statusText || 
                                    error.message || 
                                    'Unknown error occurred';
                                    
                this.setState({ 
                    errorMsg: 'Failed to load domains: ' + errorMessage,
                    isLoading: false,
                    showErrorSnackbar: true,
                    errorSnackbarMsg: 'Failed to load domains: ' + errorMessage
                });
            });
    }

    saveDomainsToBackend = (domains) => {
        this.setState({ isLoading: true });
        
        EmailDomainService.updateRestrictedDomains(domains)
            .then(response => {
                // Check if response is successful (status 2xx)
                if (response && response.status >= 200 && response.status < 300) {
                    this.setState({ 
                        items: domains, // Only update items after successful save
                        saveSuccess: true,
                        isLoading: false,
                        errorMsg: ''
                    });
                    setTimeout(() => this.setState({ saveSuccess: false }), 3000);
                } else {
                    // Handle non-2xx responses that don't trigger catch block
                    throw new Error('Failed to update domains');
                }
            })
            .catch(error => {
                const errorMessage = error.response?.data?.message || 
                                    error.response?.statusText || 
                                    error.message || 
                                    'Unknown error occurred';
                
                this.setState({ 
                    errorMsg: 'Failed to save domains: ' + errorMessage,
                    isLoading: false,
                    showErrorSnackbar: true,
                    errorSnackbarMsg: 'Failed to save domains: ' + errorMessage
                });
                
                console.error('Error updating domains:', error);
            });
    }

    componentDidMount() {
        this.getUser();
        this.loadDomains();
    }

    getUser = () => {
        let user = AuthenticationService.getMirrorUser();
        if(isEmpty(user)) {
            user = AuthenticationService.getLoggedInUserName();
        }
        this.setState({ currentUser: user });
    }

    isValidDomain = (domain) => {
        // More comprehensive regex for domain validation
        const domainRegex = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/i;
        return domainRegex.test(domain);
    }

    handleSave = () => {
        const { emailDomain, items } = this.state;
        
        // Validate domain
        if (emailDomain.trim()) {
            if (this.isValidDomain(emailDomain)) {
                if (!items.includes(emailDomain)) {
                    // Create updated list but don't update state yet
                    const updatedItems = [...items, emailDomain];
                    
                    // Clear input field immediately for better UX
                    this.setState({
                        emailDomain: '',
                        errorMsg: ''
                    });
                    
                    // Save to backend - items state will be updated only on success
                    this.saveDomainsToBackend(updatedItems);
                } else {
                    this.setState({ errorMsg: 'This domain is already in the list.' });
                }
            } else {
                this.setState({ errorMsg: 'Please enter a valid domain format (e.g., example.com).' });
            }
        } else {
            this.setState({ errorMsg: 'Please enter a domain before adding.' });
        }
    }

    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    // Open confirmation dialog
    handleConfirmDelete = (domain) => {
        this.setState({
            confirmDialogOpen: true,
            domainToDelete: domain
        });
    };

    // Handle dialog close with cancel
    handleCancelDelete = () => {
        this.setState({
            confirmDialogOpen: false,
            domainToDelete: null
        });
    };

    // Handle dialog close with confirmation
    handleConfirmDeleteSubmit = () => {
        const { domainToDelete, items } = this.state;
        
        if (domainToDelete) {
            // Create updated list but don't update state yet
            const updatedItems = items.filter(item => item !== domainToDelete);
            
            // Close dialog
            this.setState({
                confirmDialogOpen: false,
                domainToDelete: null
            });
            
            // Save to backend - items state will be updated only on success
            this.saveDomainsToBackend(updatedItems);
        }
    };
    
    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.handleSave();
        }
    };

    handleCloseSnackbar = () => {
        this.setState({ saveSuccess: false });
    };
    
    handleCloseErrorSnackbar = () => {
        this.setState({ showErrorSnackbar: false });
    };

    render() {
        const { classes } = this.props;
        const { 
            emailDomain, 
            items, 
            errorMsg, 
            isLoading, 
            saveSuccess, 
            showErrorSnackbar, 
            errorSnackbarMsg,
            confirmDialogOpen,
            domainToDelete
        } = this.state;

        return (
            <Fragment>
                <div>
                    <h1 className='App-page-label'>Manage Restricted Email Domains</h1>                   

                    <div className="step-main">
                        <Grid container direction="column">  
                            <Grid item style={{width:'50%', textAlign:'left'}}>
                                <div className={classes.inputContainer}>
                                    <TextField 
                                        name="emailDomain" 
                                        id="emailDomain" 
                                        label="New Domain"                                                                
                                        value={emailDomain}     
                                        onChange={this.handleInputChange}
                                        onKeyPress={this.handleKeyPress}                           
                                        fullWidth
                                        required
                                        error={!!errorMsg}
                                        helperText={errorMsg}
                                        style={{ flexGrow: 1 }}
                                        disabled={isLoading}
                                    />
                                    <Button 
                                        variant="contained" 
                                        color="primary" 
                                        onClick={this.handleSave}
                                        className={classes.button}
                                        disabled={isLoading}
                                    >
                                        ADD
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>                
                    </div>         
                    <div>
                        <Grid container direction="column">  
                            <Grid item style={{width:'100%', textAlign:'left', marginTop: '16px'}}>
                                <h1 className='App-page-label'>Restricted Domains</h1>     
                                <Paper elevation={1} className={classes.domainsBox}>
                                    {isLoading && <Typography>Loading...</Typography>}
                                    {!isLoading && items.length > 0 ? (
                                        <div className={classes.domainsList}>
                                            {items.map((item) => (
                                                <div key={item} className={classes.domainItem}>
                                                    <Typography variant="body2" style={{ marginRight: '8px' }}>
                                                        {item}
                                                    </Typography>
                                                    <IconButton 
                                                        edge="end" 
                                                        size="small" 
                                                        onClick={() => this.handleConfirmDelete(item)}
                                                        disabled={isLoading}
                                                    >
                                                        <CloseIcon fontSize="small" />
                                                    </IconButton>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        !isLoading && (
                                            <Typography className={classes.emptyMessage}>
                                                No email domains added yet. Add domains to restrict user registration.
                                            </Typography>
                                        )
                                    )}
                                </Paper>
                            </Grid>
                        </Grid>
                    </div>
                    
                    {/* Success Snackbar */}
                    <Snackbar
                        open={saveSuccess}
                        autoHideDuration={3000}
                        onClose={this.handleCloseSnackbar}
                        message="Domains updated successfully"
                        action={
                            <IconButton
                                size="small"
                                color="inherit"
                                onClick={this.handleCloseSnackbar}
                            >
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        }
                    />
                    
                    {/* Error Snackbar */}
                    <Snackbar
                        open={showErrorSnackbar}
                        autoHideDuration={6000}
                        onClose={this.handleCloseErrorSnackbar}
                        ContentProps={{
                            className: classes.errorSnackbar
                        }}
                        message={errorSnackbarMsg}
                        action={
                            <IconButton
                                size="small"
                                color="inherit"
                                onClick={this.handleCloseErrorSnackbar}
                            >
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        }
                    />
                    
                    {/* Confirmation Dialog */}
                    <Dialog
                        open={confirmDialogOpen}
                        onClose={this.handleCancelDelete}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {"Confirm Domain Removal"}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Are you sure you want to remove <strong>{domainToDelete}</strong> from the restricted domains list?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleCancelDelete} color="primary">
                                Cancel
                            </Button>
                            <Button 
                                onClick={this.handleConfirmDeleteSubmit} 
                                className={classes.deleteButton} 
                                variant="contained" 
                                autoFocus
                            >
                                Remove
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>                
            </Fragment>
        );
    }
}

export default withStyles(styles)(EmailDomains);